<ng-container *ngIf="abierto">
    <div>
    <div [hidden]="consulta" class="evaluacion">
        <div class="row margen">
            <div class="col-lg-12">
                <section class="widget evaluacion__preguntas">
                    <div *ngIf="tipovisualizacionpregunta == 2">
                        <div *ngFor="let competencia of listapreguntas; index as index">

                            <!-- Competencia -->
                            <div class="row" *ngIf="tipovisualizacioncompetenciacriterio == 2">
                                <div class="col-12 evaluacion__preguntas__competencia" style="box-shadow: 0 0 10px -6px {{competencia.color}}; background: {{competencia.color}}">
                                    <div class="{{competencia.colortext}} evaluacion__preguntas__competencia__titulo">
                                        <span>{{competencia.nombre}}</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let criterio of competencia.listacriterio; index as index">

                                <!-- criterio -->
                                <div class="evaluacion__preguntas__criterio" *ngIf="tipovisualizacioncompetenciacriterio == 2">
                                    <i class="fa fa-circle" aria-hidden="true" style="color: {{competencia.color}}"></i>
                                    <span class="evaluacion__preguntas__criterio__texto">{{criterio.nombre}}</span>
                                </div>

                                <!-- preguntas-->
                                <div *ngIf="tipovisualizacionrespuesta == 2">
                                    <div *ngFor="let pregunta of criterio.listapreguntas; index as index">

                                        <!-- Pregunta -->
                                        <div class="evaluacion__preguntas__pregunta">
                                            <span style="background-color: {{pregunta.color}}">{{index+ 1}}.-{{pregunta.pregunta}}</span>
                                        </div>
    
                                        <div *ngIf="pregunta.tipopreguntaid == 1; else elseBlock">
                                            <div *ngFor="let opciones of pregunta.opciones; index as index">
                                                <div class="row" *ngIf="opciones.mostrartexto">
                                                        <radiobuttoncustom [(ngModel)]="opciones.seleccionada" [radioValor]="opciones.escalaevaluacionvalorid" [grupo]="pregunta.preguntaid"  [titulo]="opciones.nombre" (ngModelChange)="Guardarrespuesta(pregunta, $event, opciones, criterio)"></radiobuttoncustom>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-template #elseBlock>
                                            <div>
                                                <textareaCustom #elseBlock [errorActivo]="false" [(ngModel)]="pregunta.respuestaabierta" [verError]="false" (event)="Guardarrespuesta(pregunta, $event, 0, criterio)"></textareaCustom>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                                <div *ngIf="tipovisualizacionrespuesta == 1">
                                    <h2 style="text-align: center;">{{criterio.listapreguntas[conteopregunta].pregunta}}</h2>
                                    <div class="divisor8"></div>
                                    <div class="grupo-icono">
                                        <ng-container *ngFor="let opciones of criterio.listapreguntas[conteopregunta].opciones; let i = index">
                                          <div *ngIf="opciones.icono && opciones.mostrarimagen" class="iconoalumno">
                                            <img (click)="Guardarrespuesta(criterio.listapreguntas[conteopregunta], criterio.listapreguntas[conteopregunta].opciones[i].escalaevaluacionvalorid)" style="width: 150px;" [src]="opciones.icono | Base64Seguro"  />
                                            <p *ngIf="opciones.mostrartexto">{{opciones.nombre}}</p>
                                          </div>
                                          <!-- Insertar un divisor después de cada grupo de cinco imágenes -->
                                          <div class="divisoralumno" *ngIf="(i + 1) % 4 === 0"></div>
                                        </ng-container>
                                      </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h3>Observaciones o comentarios generales</h3>
                            <div>
                                <span>Si lo deseas, puedes capturar observaciones o comentarios referentes a la evaluación de esta persona</span>
                                <textareaCustom [errorActivo]="false" [verError]="false" [(ngModel)]="objobservacion.observaciones"  (event)="GuardarComentario($event)"></textareaCustom>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="tipovisualizacionpregunta == 1">
                        <div class="row" *ngIf="tipovisualizacioncompetenciacriterio == 2">
                            <div class="col-12 evaluacion__preguntas__competencia" style="box-shadow: 0 0 10px -6px {{competencia.color}}; background: {{competencia.color}}">
                                <div class="{{competencia.colortext}} evaluacion__preguntas__competencia__titulo">
                                    <span>{{competencia.nombre}}</span>
                                </div>
                            </div>
                        </div>
                                <div class="evaluacion__preguntas__criterio" *ngIf="tipovisualizacioncompetenciacriterio == 2">
                                    <i class="fa fa-circle" aria-hidden="true" style="color: {{competencia.color}}"></i>
                                    <span class="evaluacion__preguntas__criterio__texto">{{criterio.nombre}}</span>
                                </div>

                                <div *ngIf="tipovisualizacionrespuesta == 1">
                                    <h2 class="centrartexto">{{conteopregunta+1}}- {{pregunta.pregunta}}</h2>
                                    <div class="divisor8"></div>
                                    <div class="grupo-icono">
                                        <ng-container *ngFor="let opciones of pregunta.opciones; let i = index">
                                                <div *ngIf="opciones.icono && opciones.mostrarimagen" class="iconoalumno">
                                                    <img (click)="Guardarrespuesta(pregunta, pregunta.opciones[i].escalaevaluacionvalorid)" class="clickimagen" [src]="opciones.icono | Base64Seguro"  />
                                                        <h5 *ngIf="opciones.mostrartexto">{{opciones.nombre}}</h5>
                                                    <radiobuttoncustom [(ngModel)]="pregunta.opciones[i].seleccionada" *ngIf="opciones.mostrartexto" [disabled]="true" [radioValor]="pregunta.opciones[i].escalaevaluacionvalorid"></radiobuttoncustom>
                                                  </div>
                                                  <!-- Insertar un divisor después de cada grupo de cinco imágenes -->
                                                  <div class="divisoralumno" *ngIf="(i + 1) % 4 === 0"></div>
                                        </ng-container>
                                      </div>
                                </div>
                    </div>

                    <div class="divisor20"></div>

                    <div class="row margen" *ngIf="tipovisualizacionpregunta == 2 || prevista == 1">
                        <div class="col-12">
                            <div class="centrarboton">
                                <button matTooltip="Cerrar evaluacion" class="boton botonSM filledBlanco"
                                (click)="Salir()">
                                <span> {{'Salir de la evaluación'}}</span>
                            </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
</ng-container>


